import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { CUSTOM_QUERY_FORM_NAME } from 'Common/FormEnum';
import CustomQueryList from '../../components/customQueryList/CustomQueryList';

class CustomQueryListContainer extends Component {
  render() {
    return <CustomQueryList {...this.props} />;
  }
}

export const CustomQueryListForm = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: CUSTOM_QUERY_FORM_NAME,
})(CustomQueryListContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/customqueries/containers/customQueryList/CustomQueryListForm.js